<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.billing_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title v-if="student">Facturación : {{ student.names+" "+student.paternal_surname }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text v-if="student">
                <v-container fluid>
                    <v-row>
                        <v-col lg="3" md="4" sm="12" xs="12">
                            <v-card>
                                <v-list two-line subheader>
                                    <v-list-item>
                                        <v-list-item-avatar>
                                            <v-icon color="#008dd4" x-large>mdi-currency-usd</v-icon>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title><strong>Balance</strong></v-list-item-title>
                                            <v-list-item-subtitle class="text-h3" v-if="item.balance">${{ item.balance.balance }}</v-list-item-subtitle>
                                        </v-list-item-content>

                                    </v-list-item>
                                </v-list>
                            </v-card>

                            <v-btn class="mt-3" color="success" block @click="new_proof_dialog = !new_proof_dialog">Registrar comprobante</v-btn>
                        </v-col>
                        <v-col lg="9" md="8" sm="12" xs="12" class="elevation-1">
                            <v-data-table
                                :headers="headers"
                                :items="item.payments"
                                :loading="loading"
                                :footer-props="footer_props"
                                :loading-text="loading_text"
                                :no-data-text="no_data_text"
                                :no-results-text="no_result_text"
                                :search="search"
                            >
                                <template v-slot:item.proof="{ item }">
                                    <v-btn v-if="item.proof" icon @click="() => { proof_name = item.proof.proof; proof_dialog = true }">
                                        <v-icon>mdi-image</v-icon>
                                    </v-btn>
                                    <span v-else>N/A</span>
                                </template>

                                <template v-slot:item.quantity="{ item }">
                                    <span class="red--text darken-1" v-if="item.quantity > 0">0</span>
                                    <span class="red--text darken-1" v-else>{{ item.quantity }}</span>
                                </template>

                                <template v-slot:item.payment="{ item }">
                                    <span class="green--text darken-1" v-if="item.verified == 1 || item.type == 'Account Deposit'">{{ Math.abs(item.quantity) }}</span>
                                    <span class="green--text darken-1" v-else>0</span>
                                </template>

                                <template v-slot:item.status="{ item }">
                                    <v-chip v-if="item.status > 0" color="red" text-color="white">Pendiente</v-chip>
                                    <v-chip v-else-if="item.type == 'Promotion'" color="primary">Promocíon</v-chip>
                                    <v-chip v-else-if="item.type == 'Account Deposit'" color="secondary">Abono a cuenta</v-chip>
                                    <v-chip v-else color="success">Pago correcto</v-chip>
                                </template>

                                <template v-slot:item.actions="{ item }">
                                    <v-tooltip right>
                                        <template v-slot:activator="{ attrs, on }">
                                            <v-btn icon v-if="item.status > 0" v-bind="attrs" v-on="on" @click="() => { delete_payment_dialog = true;  delete_payment_item = item }">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Eliminar</span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <v-dialog v-model="proof_dialog" max-width="800">
            <v-card>
                <v-card-title>Comprobante</v-card-title>
                <v-card-text>
                    <v-img v-if="proof_name" :src="proof_url+proof_name"></v-img>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="proof_dialog = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="new_proof_dialog" max-width="800">
            <v-card>
                <v-card-title>Nuevo comprobante de pago</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row align="center" justify="center">
                            <v-col cols="12">
                                <v-form ref="new_proof_form" v-on:submit.prevent="new_proof">
                                    <v-text-field v-model="quantity" filled :rules="[rules.required]" type="number" min="1" label="Cantidad depositada"></v-text-field>
                                    <v-text-field v-model="reference" filled :rules="[rules.required]" label="Referencia"></v-text-field>
                                    <v-file-input v-model="proof[0]" filled :color="color" :rules="[rules.required]" prepend-icon="" label="Comprobante de pago"></v-file-input>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="new_proof_dialog = false" :disabled="proof_loading">Cancelar</v-btn>
                    <v-btn color="#008dd4" dark @click="new_proof" :loading="proof_loading">Registrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="delete_payment_dialog" max-width="400" persistent>
            <v-card>
                <v-card-title>Eliminar pago</v-card-title>
                <v-card-text class="text-center">
                    ¿Realmente desea eliminar el pago?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="delete_payment_dialog = false">Cancelar</v-btn>
                    <v-btn color="primary" @click="delete_payment()">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog','student'],
    data: () => ({
        //items
        item:"",

        //urls
        store_proof_url:"/students/store_proof",
        get_data:"/students/proofs",
        delete_payment_url:"/students/payment/delete",

        //proof_url
        proof_url:"/storage/payment_proofs/",
        proof_name:"",

        //loadings
        proof_loading:false,

        //dialog
        proof_dialog:false,
        new_proof_dialog:false,
        delete_payment_dialog:false,

        //rules
        rules:{
            required: v => !!v || 'El campo es requerido',
        },

        //data table props
        color:"#818181",
        search:"",
        loading:false,
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'Folio', value:'id' },
            { text:'Fecha', value:'date' },
            { text:'Concepto', value:'description' },
            { text:'Comprobante', value:'proof'},
            { text:'Cantidad', value:'quantity'},
            { text:'Abono', value:'payment' },
            { text:'Estado', value:'status' },
            { text:'Acciones', value:'actions' }
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo"
        },

        //models
        quantity:"",
        reference:"",
        proof:[],
        delete_payment_item:"",
    }),

    watch:{
        student:function(){
            this.get_data_fn()
        }
    },

    methods:{
        get_data_fn:function()
        {
            axios.get(this.get_data, { params:{ ajax:true, student_id:this.student.id }}).then(response => {
                this.item = response.data.student
            }).catch(() => {
                iziToast.error({
                    title:"Error",
                    position:'topRight',
                    message: "Error al obtener información"
                })
            })
        },
        
        new_proof:function(){
            if(this.$refs.new_proof_form.validate()){
                this.proof_loading = true

                let data = new FormData()
                data.append('quantity', this.quantity)
                data.append('user_id', this.student.id)
                data.append('reference', this.reference)
                data.append('proof', this.proof[0])

                axios.post(this.store_proof_url, data).then(response => {

                    this.new_proof_dialog = this.$parent.billing_dialog = false
                    this.$refs.new_proof_form.reset()
                    this.$parent.getData()

                    iziToast.success({
                        title:"Correcto",
                        message:"El comprobante ha sido registrado correctamente",
                        position:"topRight"
                    })

                }).catch(error => {
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }else{
                        iziToast.error({
                            title:"Error",
                            position:'topRight',
                            message: error.response.data.error
                        })
                    }
                })

                this.proof_loading = false
            }
        },

        delete_payment:function()
        {
            axios.post(this.delete_payment_url, { payment_id: this.delete_payment_item.id, student_id:this.student.id })
            .then(() => {
                this.delete_payment_dialog = false
                this.get_data_fn()

                iziToast.success({
                    title:"Correcto",
                    position:'topRight',
                    message: "pago pendiente eliminado correctamente"
                })
            })
        }
    }
}
</script>
